<!-- 选择已有发票信息弹框 -->
<template>
    <el-drawer @close="close" direction="btt" size="50%" append-to-body :visible.sync="drawer" :with-header="false">
        <div style="padding: 20px;text-align: center;position: relative;">
            <span style="font-weight: bold;font-size: 20px;"> 选择已有发票信息</span>
            <el-button style="position: absolute;right: 20px;" @click="save" type="primary">保 存</el-button>
        </div>
        <el-table v-loading="loading" border :data="tableData" stripe style="width: 100%">
            <el-table-column align="center" width="55">
                <template slot-scope="scope">
                    <div v-if="drawer">
                        <el-checkbox @change="selectRowClick(scope.row)"
                            :checked="selectRows.findIndex(n => n.id === scope.row.id) > -1"
                            v-if="multipleChoiceOrNot"></el-checkbox>
                        <el-radio v-model="selectId" :label="scope.row.id" @change="selectRowClick(scope.row)"
                            v-else>&nbsp;</el-radio>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="发票类型" width="180">
                <template slot-scope="scope">
                    {{ mapInvoicingType[scope.row.invoicingType] }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="lookUp" label="发票抬头" width="180">
            </el-table-column>
            <el-table-column align="center" prop="duty" label="税号">
            </el-table-column>
            <el-table-column align="center" prop="invoicingPrice" label="发票金额">
            </el-table-column>
            <el-table-column align="center" prop="email" label="邮箱地址">
            </el-table-column>
            <el-table-column align="center" prop="address" label="地址">
            </el-table-column>
            <el-table-column align="center" prop="telephone" label="电话">
            </el-table-column>
            <el-table-column align="center" prop="openingBank" label="开户行">
            </el-table-column>
            <el-table-column align="center" prop="openingBankAccount" label="账号">
            </el-table-column>
            <el-table-column align="center" prop="invoicingRemark" label="发票备注">
            </el-table-column>
        </el-table>
    </el-drawer>
</template>

<script>
import Api from '@/components/Api';
export default {
    components: {},
    props: {
        //是否多项
        multipleChoiceOrNot: {
            type: Boolean,
            default: false
        },
        planId: {
            type: Number,
            default: null
        },
        tableData: {
            type: Array,
            default: () => []
        },
        //是否组件获取数据
        isGetData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            drawer: false,
            loading: false,
            selectRows: [],//勾选的数据
            selectId: null, //单选勾选的数据id
            mapInvoicingType: {
                '0': '企业',
                '1': '个人',
                '2': '非企业性单位'
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        //保存
        save() {
            this.$emit('selectInvoice', this.selectRows)
            this.drawer = false
        },
        open() {
            this.drawer = true
            if (this.isGetData) {
                this.getDatas()
            }
        },
        close() {
            this.selectRows = []
        },
        selectRowClick(row) {
            if (this.multipleChoiceOrNot) {
                if (this.selectRows.findIndex(n => n.id === row.id) === -1) {
                    this.selectRows.push(row)
                } else {
                    this.selectRows.splice(this.selectRows.findIndex(n => n.id === row.id), 1)
                }
            } else {
                this.selectRows = [row]
            }
        },
        getDatas() {
            this.loading = true
            new Api('user').selectPlanInvoice(this.planId).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data
                    this.loading = false
                } else {
                    this.loading = false
                }
            })
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.el-radio input[aria-hidden="true"] {
    display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>